var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "724",
      "width": "100%",
      "content-class": "rounded-lg",
      "eager": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-sheet', {
    staticClass: "fill-height"
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "fill-height": ""
    }
  }, [_c('bottom-sheet-header', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "fab": "",
      "tile": "",
      "absolute": "",
      "right": "",
      "color": "white"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('showComplete');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "scroll-primary",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-y": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "pa-40 pa-lg-60"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("송부 완료")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm._v(" 계약서가 송부 되었습니다. "), _c('br'), _vm._v(" 근로자 현황에서 확인 가능합니다. ")])]), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('showComplete');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("확인")])]), _c('texting-dialog', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v("문자발송")])])];
      }
    }])
  }, 'texting-dialog', _vm.textingProps, false))], 1)])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }